export const updateCookieSettings = () => {
  // The cookie solution uses a callback when the settings widget is closed
  // ('OnBannerClosed') which triggers the event "cookie_update_force_refresh".
  // Page reload may be necessary in case cookie permissions have been withdrawn for certain purposes to
  // ensure now (after withdrawl) cookie-setting services are no longer active.
  document.addEventListener("cookie_update_force_refresh", function () {
    document.location.reload()
  })
  // Open iubenda cookie solution
  window._iub.cs.ui.mustShowPerPurposeView = true
  window._iub.cs.ui.showCP()
}
